import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { usePremiumDiscountActivationMutation } from 'hooks/mutations/usePremiumDiscountActivationMutation';
import { updateFeatureFlag } from 'store/common/commonSlice';
import { isLimitTimeOfferEnabledSelector } from 'store/common/selectors';
import {
  setCredits,
  setUpgradePackages,
  setUpsalePackages,
} from 'store/payment/paymentSlice';

import { useLimitTimeOfferPopupAnalytics } from './useLimitTimeOfferPopupAnalytics';

export const useLimitTimeOfferPopupBL = () => {
  const dispatch = useDispatch();

  const isLimitedTimeOfferEnabled = useSelector(
    isLimitTimeOfferEnabledSelector
  );

  const { trackShow } = useLimitTimeOfferPopupAnalytics();

  const premiumDiscountActivationMutation =
    usePremiumDiscountActivationMutation({
      onSuccess: (data) => {
        dispatch(
          updateFeatureFlag({
            flag: 'isLimitTimeOfferEnabled',
            value: false,
          })
        );
        dispatch(setUpgradePackages(data.packages));
        dispatch(setUpsalePackages(data.upsale_packages));

        if (data.credits) {
          dispatch(setCredits(data.credits));
        }
      },
    });

  useEffect(() => {
    trackShow();

    if (isLimitedTimeOfferEnabled) {
      premiumDiscountActivationMutation.mutate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLimitedTimeOfferEnabled]);
};
